import React, {PropTypes} from 'react';

import * as color from '../../../constants/colors';

import FlatButton from '../../common/buttons/FlatButton';


class DeleteWarning extends React.Component {


  constructor(props) {
    super(props);
    this.state = {};
  }

  getActionClass() {
    return this.props.actionClass ? 'modalActions ' + this.props.actionClass : 'modalActions';
  }

  getDeleteActions() {
    return [
      <FlatButton
        key='cancel'
        label='Cancel'
        style={{float:'right'}}
        labelStyle={{fontWeight: '700'}}
        onClick={this.props.cancelMethod.bind(this)} />,
      <FlatButton
        key='confirm'
        label='Delete'
        disabled={this.state.sendingRequest}
        style={{float:'right'}}
        labelStyle={{fontWeight: '700', color: color.ERROR_RED}}
        onClick={this.props.deleteMethod.bind(this)} />,
    ];
  }

  render() {
    let actions = this.getDeleteActions();
    return (
      <div className='DeleteWarning'>
        <div>
          <div className='confirmTitle'>Are you sure?</div>
          <div className='confirmSubtitle'>This can't be undone</div>
        </div>
        <div className={this.getActionClass()}>
          {actions.map(action => {
            return action;
          })}
        </div>
      </div>
    );
  }
}
export default DeleteWarning;